import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import Loader from "../../shared/loader";
import CustomCropper from "../../shared/customCropper";
import Select from "react-select";

const Add = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const designRef = useRef();
  const faceRef = useRef();
  const preiviewRef = useRef();
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [seriesDrp, setSeriesDrpData] = useState([]);
  const [userDrp, setUserDrpData] = useState([]);
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [facePreiviewIndex, setFacePreiviewIndex] = useState(-1);
  const [isAllowed, setIsAllowed] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    size_id: "",
    series_id: "",
    user_id: "",
    image: "",
    is_hide_preview: false,
    imagePreview: "",
    preview: "",
    previewImage: "",
    face: "",
    facePreview1: "",
    facePreview2: "",
    facePreview3: "",
    facePreview4: "",
    facePreview5: "",
    facePreview6: "",
  });

  const getSizeDrpData = () => {
    axios.post(API_URL.SIZE_LIST, { user_id: formData.user_id }).then((res) => {
      setSizeDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeDrpData(cd);
    });
  };

  const getSeriesDrpData = () => {
    axios
      .post(API_URL.SERIES_LIST, { user_id: formData.user_id })
      .then((res) => {
        setSeriesDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setSeriesDrpData(cd);
      });
  };

  const getUser = () => {
    axios.post(API_URL.USER_LIST, {}).then((res) => {
      setUserDrpData(res.data.data.data);
      let cd = res.data.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setUserDrpData(cd);
    });
  };

  const saveProduct = () => {
    setLoading(true);
    if (
      formData.name &&
      formData.size_id &&
      formData.series_id &&
      formData.user_id
    ) {
      if (!id && !formData.image) {
        setError(true);
        toast.error("Please enter valid details", {
          autoClose: 3000,
          position: "top-center",
        });
        return false;
      }
      setError(false);
      var prodFormData = new FormData();
      if (formData.image) {
        prodFormData.append("image", formData.image);
      }
      if (formData.face) {
        for (let i = 0; i < formData.face.length; i++) {
          prodFormData.append("face[]", formData.face[i]);
        }
      }
      console.log(formData.preview)
      if (formData.preview) {
        prodFormData.append("preview", formData.preview);
      }
      prodFormData.append("name", formData.name);
      if (formData.series_id && formData.series_id) {
        prodFormData.append("series_id", formData.series_id);
      }
      if (formData.size_id && formData.size_id.length) {
        formData.size_id.forEach((element) => {
          prodFormData.append("size_id[]", element.value);
        });
      }
      if (id) {
        prodFormData.append("id", id);
      }
      prodFormData.append("user_id", formData.user_id);
      prodFormData.append("is_hide_preview", (formData.is_hide_preview) ? 1: 0);
      const pUrl = id ? API_URL.PRODUCT_UPDATE : API_URL.PRODUCT_SAVE;
      axios.post(pUrl, prodFormData).then((res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", {
              autoClose: 3000,
              position: "top-center",
            });
            setTimeout(() => {
              navigate("/admin/product", { replace: true });
            }, 100);
          } else {
            setTimeout(() => {
              navigate("/admin/product", { replace: true });
            }, 100);
            toast.success("Saved", { autoClose: 3000, position: "top-center" });
          }
        } else {
          toast.error(res.data.data, {
            autoClose: 3000,
            position: "top-center",
          });
        }
        setLoading(false);
      });
    } else {
      setError(true);
      toast.error("Please enter valid details", {
        autoClose: 3000,
        position: "top-center",
      });
      setLoading(false);
    }
  };

const onEdit = () => {
    setLoading(true);

    debugger;
    axios.post(API_URL.PRODUCT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          category_id: res.data.data.category_id + "",
          size_id: res.data.data.size_id ? res.data.data.size_id : "",
          series_id: res.data.data.series_id ? res.data.data.series_id : "",
          is_hide_preview: res.data.data.is_hide_preview == 1 ? true : false,
          user_id: res.data.data.user_id ? res.data.data.user_id : "",
          image: null,
          imagePreview: res.data.data.image ? res.data.data.image : "",
          face: null,
          facePreview1: res.data.data.face_one ? res.data.data.face_one : "",
          facePreview2: res.data.data.face_two ? res.data.data.face_two : "",
          facePreview3: res.data.data.face_three
            ? res.data.data.face_three
            : "",
          facePreview4: res.data.data.face_four ? res.data.data.face_four : "",
          facePreview5: res.data.data.face_five ? res.data.data.face_five : "",
          facePreview6: res.data.data.face_six ? res.data.data.face_six : "",
          preview: null,
          previewImage: res.data.data.preview ? res.data.data.preview : "",
        });
      }
      setLoading(false);
    });
  };

  const allowedFileTypes = ["image/jpeg", "image/png", "image/jpg"];
  const onChangeDesign = (event) => {
    if (event.target.files) {
      let file = event.target.files[0];
      if (!allowedFileTypes.includes(file.type)) {
        toast.error("Only JPEG, JPG, and PNG files are allowed.");
        setFormData({ ...formData, image: null, imagePreview: "" });
        designRef.current.value = "";
        return;
      }
      if (file.size > 2 * 1000 * 1024) {
        toast.error("File size less then or equal to 2MB.");
        setFormData({ ...formData, image: null, imagePreview: "" });
        designRef.current.value = "";
      } else {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(reader.result);
          setFormData({
            ...formData,
            image: file,
            imagePreview: reader.result,
          });
        };
      }
    } else {
      setFormData({ ...formData, image: null, imagePreview: "" });
      designRef.current.value = "";
    }
  };

  const allowedFilesTypes = ["image/jpeg", "image/png", "image/jpg"];
  const onChangePreview = (event) => {
    if (event.target.files) {
      let file = event.target.files[0];
      if (!allowedFilesTypes.includes(file.type)) {
        toast.error("Only JPEG, JPG, and PNG files are allowed.");
        setFormData({ ...formData, preview: null, previewImage: "" });
        preiviewRef.current.value = "";
        return;
      }
      if (file.size > 2 * 1000 * 1024) {
        toast.error("File size less then or equal to 2MB.");
        setFormData({ ...formData, preview: null, previewImage: "" });
        preiviewRef.current.value = "";
      } else {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(reader.result);
          setFormData({
            ...formData,
            preview: file,
            previewImage: reader.result,
          });
        };
      }
    } else {
      setFormData({ ...formData, preview: null, previewImage: "" });
      preiviewRef.current.value = "";
    }
  };

  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
}

  const onChangeFace = (event) => {
    if (event.target.files) {
      let files = event.target.files;
      let isSizeError = false;
      let isTypeError = false;

      // Check file types and sizes
      for (let i = 0; i < files.length; i++) {
        if (files[i] && files[i].size > 2 * 1000 * 1024) {
          isSizeError = true;
        }
        if (!["image/jpeg", "image/jpg", "image/png"].includes(files[i].type)) {
          isTypeError = true;
        }
      }

      if (isTypeError) {
        toast.error("Only JPEG, JPG, and PNG files are allowed.");
        setFormData({
          ...formData,
          face: null,
          facePreview1: "",
          facePreview2: "",
          facePreview3: "",
          facePreview4: "",
          facePreview5: "",
          facePreview6: "",
        });
        faceRef.current.value = "";
        return;
      }

      if (isSizeError) {
        toast.error("File size must be less than or equal to 2MB.");
        setFormData({
          ...formData,
          face: null,
          facePreview1: "",
          facePreview2: "",
          facePreview3: "",
          facePreview4: "",
          facePreview5: "",
          facePreview6: "",
        });
        faceRef.current.value = "";
        return;
      }

      // If no errors, set the files and start preview
      setFormData({ ...formData, face: files });
      setFacePreiviewIndex(0);
    } else {
      setFormData({
        ...formData,
        face: null,
        facePreview1: "",
        facePreview2: "",
        facePreview3: "",
        facePreview4: "",
        facePreview5: "",
        facePreview6: "",
      });
      faceRef.current.value = "";
    }
  };

  const getFacePreview = () => {
    if (formData.face[facePreiviewIndex]) {
      var reader = new FileReader();
      reader.readAsDataURL(formData.face[facePreiviewIndex]);
      reader.onload = function () {
        setFormData({
          ...formData,
          ["facePreview" + (facePreiviewIndex + 1)]: reader.result,
        });
        if (facePreiviewIndex < 5) {
          setFacePreiviewIndex(facePreiviewIndex + 1);
        } else {
          setFacePreiviewIndex(-1);
        }
      };
    } else {
      if (facePreiviewIndex < 5) {
        setFormData({
          ...formData,
          ["facePreview" + (facePreiviewIndex + 1)]: "",
        });
        setFacePreiviewIndex(facePreiviewIndex + 1);
      } else {
        setFormData({
          ...formData,
          ["facePreview" + (facePreiviewIndex + 1)]: "",
        });
        setFacePreiviewIndex(-1);
      }
    }
  };

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
      if (res.data) {
        setIsAllowed(res.data.is_allowed);
        if (!res.data.is_allowed) {
          if (id) {
            onEdit();
          } else {
            setFormData({ ...formData, user_id: res.data.id });
          }
        } else {
          getUser();
          if (id) {
            onEdit();
          }
        }
      }
    });
  };

  useEffect(() => {
    if (facePreiviewIndex > -1) {
      getFacePreview();
    }
  }, [facePreiviewIndex]);

  useEffect(() => {
    if (formData.user_id) {
      getSeriesDrpData();
      getSizeDrpData();
    }
  }, [formData.user_id]);

  useEffect(() => {
    userInfo();
  }, []);

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };
  const getInputStyles = (isError) => ({
    borderColor: isError ? "red" : undefined,
  });
  const isShowError = (value) => {
    if (
      isError &&
      (!value || value == "" || value == null || value == undefined)
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Edit" : "Add"} Product</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link
                  to={"/admin/product"}
                  className="btn btn-sm btn-secondary"
                >
                  <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
        {loading && <Loader></Loader>}
        {!loading && (
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  {isAllowed && (
                    <div className={isAllowed ? "col-md-3" : "col-md-4"}>
                      <div className="form-group">
                        <label
                          className={`form-label ${
                            isShowError(formData.user_id) && "required-field"
                          }`}
                        >
                          Client<span className="required-star">*</span>
                        </label>
                        <Select
                          options={userDrp}
                          value={userDrp.find(
                            (r) => r.value === formData.user_id
                          )}
                          styles={{
                            ...styles,
                            control: (base) => ({
                              ...base,
                              borderColor: isShowError(formData.user_id)
                                ? "red"
                                : base.borderColor,
                            }),
                          }}
                          onChange={(e) => {
                            setFormData({ ...formData, user_id: e.value });
                          }}
                        />
                      </div>
                    </div>
                  )}
                  <div className={isAllowed ? "col-md-3" : "col-md-4"}>
                    <div className="form-group">
                      <label
                        className={`form-label ${
                          isShowError(formData.series_id) && "required-field"
                        }`}
                      >
                        Tiles Series<span className="required-star">*</span>
                      </label>
                      <Select
                        options={seriesDrp}
                        value={seriesDrp.find(
                          (d) => d.value === formData.series_id
                        )}
                        styles={{
                          ...styles,
                          control: (base) => ({
                            ...base,
                            borderColor: isShowError(formData.series_id)
                              ? "red"
                              : base.borderColor,
                          }),
                        }}
                        onChange={(e) => {
                          setFormData({ ...formData, series_id: e.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className={isAllowed ? "col-md-3" : "col-md-4"}>
                    <div className="form-group">
                      <label
                        className={`form-label ${
                          isShowError(formData.size_id) && "required-field"
                        }`}
                      >
                        Tiles Size<span className="required-star">*</span>
                      </label>
                      <Select
                        isMulti
                        options={sizeDrp}
                        value={formData.size_id}
                        styles={{
                          ...styles,
                          control: (base) => ({
                            ...base,
                            borderColor: isShowError(formData.series_id)
                              ? "red"
                              : base.borderColor,
                          }),
                        }}
                        onChange={(e) => {
                          setFormData({ ...formData, size_id: e });
                        }}
                      />
                    </div>
                  </div>
                  <div className={isAllowed ? "col-md-3" : "col-md-4"}>
                    <div className="form-group">
                      <label
                        className={`form-label ${
                          isShowError(formData.name) && "required-field"
                        }`}
                      >
                        Tiles Design Name
                        <span className="required-star">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        maxLength={30}
                        value={formData.name}
                        placeholder="Design Name"
                        className="form-control"
                        id="name"
                        style={getInputStyles(isShowError(formData.name))}
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label
                        className={`form-label ${
                          isShowError(formData.image) && "required-field"
                        }`}
                      >
                        Tiles Design<span className="required-star">*</span>
                      </label>
                      <input
                        type="file"
                        ref={designRef}
                        className="form-control"
                        id="imageSeries"
                        style={getInputStyles(isShowError(formData.image))}
                        onChange={onChangeDesign}
                      />
                    </div>
                    <div>
                      {formData.imagePreview && (
                        <img
                          className="me-1"
                          src={formData.imagePreview}
                          width={45}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Tiles Preview</label>
                      <CustomCropper
                        imagePreview={formData.previewImage}
                        cropShape="round"
                        guid={""}
                        onChangeCropper={async ({
                          fileCroppedBase64,
                        }) => {
                          setFormData({
                            ...formData,
                            preview: dataURLtoFile(fileCroppedBase64, 'image.png'),
                            previewImage: fileCroppedBase64
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Tiles Faces</label>
                      <input
                        multiple
                        type="file"
                        ref={faceRef}
                        maxLength={30}
                        className="form-control"
                        id="faceSeries"
                        onChange={onChangeFace}
                      />
                    </div>
                    <div>
                      {formData.facePreview1 && (
                        <img
                          className="me-1"
                          src={formData.facePreview1}
                          width={50}
                        />
                      )}
                      {formData.facePreview2 && (
                        <img
                          className="me-1"
                          src={formData.facePreview2}
                          width={50}
                        />
                      )}
                      {formData.facePreview3 && (
                        <img
                          className="me-1"
                          src={formData.facePreview3}
                          width={50}
                        />
                      )}
                      {formData.facePreview4 && (
                        <img
                          className="me-1"
                          src={formData.facePreview4}
                          width={50}
                        />
                      )}
                      {formData.facePreview5 && (
                        <img
                          className="me-1"
                          src={formData.facePreview5}
                          width={50}
                        />
                      )}
                      {formData.facePreview6 && (
                        <img
                          className="me-1"
                          src={formData.facePreview6}
                          width={50}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group text-end d-flex justify-content-end">
                  <div className="pt-2 me-3">
                    <input
                      className="form-check-input"
                      checked={formData.is_hide_preview}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          is_hide_preview: e.target.checked,
                        })
                      }
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="flexCheckDefault"
                    >
                      Hide Preview in PDF
                    </label>
                  </div>
                  <button
                    type="submit"
                    onClick={saveProduct}
                    className="btn btn-sm btn-primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Watch color={"white"} height={20} width={20} />
                      </div>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
              <div
                className="d-flex justify-content-start"
                style={{ color: "red" }}
              >
                The maximum limit of file size is 2MB
              </div>
            </div>
          </form>
        )}
        </div>
      </div>
    </>
  );
};

export default Add;
